import React from 'react';
import AreaChart from '../../../components/AreaChart';

const Chart = () => {
  const initialData = [
    // Full time for January 1st
    ...Array.from({ length: 24 }, (_, hour) => ({
      time: new Date(2023, 0, 1, hour).getTime() / 1000,
      value: 50 + hour,
    })),
    // Full days for the rest of January
    ...Array.from({ length: 30 }, (_, day) => ({
      time: new Date(2023, 0, day + 2).getTime() / 1000,
      value: 74 + day,
    })),
    // Full time for February 1st
    ...Array.from({ length: 24 }, (_, hour) => ({
      time: new Date(2023, 1, 1, hour).getTime() / 1000,
      value: 104 + hour,
    })),
    // Full days for the rest of February
    ...Array.from({ length: 27 }, (_, day) => ({
      time: new Date(2023, 1, day + 2).getTime() / 1000,
      value: 128 + day,
    })),
    // Full time for March 1st
    ...Array.from({ length: 24 }, (_, hour) => ({
      time: new Date(2023, 2, 1, hour).getTime() / 1000,
      value: 159 + hour,
    })),
    // Full days for the rest of March
    ...Array.from({ length: 30 }, (_, day) => ({
      time: new Date(2023, 2, day + 2).getTime() / 1000,
      value: 183 + day,
    })),
    // Full time for April 1st
    ...Array.from({ length: 24 }, (_, hour) => ({
      time: new Date(2023, 3, 1, hour).getTime() / 1000,
      value: 213 + hour,
    })),
    // Full days for the rest of April
    ...Array.from({ length: 29 }, (_, day) => ({
      time: new Date(2023, 3, day + 2).getTime() / 1000,
      value: 237 + day,
    })),
    // Full time for May 1st
    ...Array.from({ length: 24 }, (_, hour) => ({
      time: new Date(2023, 4, 1, hour).getTime() / 1000,
      value: 267 + hour,
    })),
    // Full days for the rest of May
    ...Array.from({ length: 30 }, (_, day) => ({
      time: new Date(2023, 4, day + 2).getTime() / 1000,
      value: 291 + day,
    })),
    // Full time for June 1st
    ...Array.from({ length: 24 }, (_, hour) => ({
      time: new Date(2023, 5, 1, hour).getTime() / 1000,
      value: 321 + hour,
    })),
    // Full days for the rest of June
    ...Array.from({ length: 29 }, (_, day) => ({
      time: new Date(2023, 5, day + 2).getTime() / 1000,
      value: 345 + day,
    })),
    // Full time for July 1st
    ...Array.from({ length: 24 }, (_, hour) => ({
      time: new Date(2023, 6, 1, hour).getTime() / 1000,
      value: 375 + hour,
    })),
    // Full days for the rest of July
    ...Array.from({ length: 30 }, (_, day) => ({
      time: new Date(2023, 6, day + 2).getTime() / 1000,
      value: 399 + day,
    })),
    // Full time for August 1st
    ...Array.from({ length: 24 }, (_, hour) => ({
      time: new Date(2023, 7, 1, hour).getTime() / 1000,
      value: 429 + hour,
    })),
    // Full days for the rest of August
    ...Array.from({ length: 30 }, (_, day) => ({
      time: new Date(2023, 7, day + 2).getTime() / 1000,
      value: 453 + day,
    })),
    // Full time for September 1st
    ...Array.from({ length: 24 }, (_, hour) => ({
      time: new Date(2023, 8, 1, hour).getTime() / 1000,
      value: 483 + hour,
    })),
    // Full days for the rest of September
    ...Array.from({ length: 29 }, (_, day) => ({
      time: new Date(2023, 8, day + 2).getTime() / 1000,
      value: 507 + day,
    })),
    // Full time for October 1st
    ...Array.from({ length: 24 }, (_, hour) => ({
      time: new Date(2023, 9, 1, hour).getTime() / 1000,
      value: 537 + hour,
    })),
    // Full days for the rest of October
    ...Array.from({ length: 30 }, (_, day) => ({
      time: new Date(2023, 9, day + 2).getTime() / 1000,
      value: 561 + day,
    })),
    // Full time for November 1st
    ...Array.from({ length: 24 }, (_, hour) => ({
      time: new Date(2023, 10, 1, hour).getTime() / 1000,
      value: 591 + hour,
    })),
    // Full days for the rest of November
    ...Array.from({ length: 29 }, (_, day) => ({
      time: new Date(2023, 10, day + 2).getTime() / 1000,
      value: 615 + day,
    })),
    // Full time for December 1st
    ...Array.from({ length: 24 }, (_, hour) => ({
      time: new Date(2023, 11, 1, hour).getTime() / 1000,
      value: 645 + hour,
    })),
    // Full days for the rest of December
    ...Array.from({ length: 30 }, (_, day) => ({
      time: new Date(2023, 11, day + 2).getTime() / 1000,
      value: 669 + day,
    })),
  ];

  const chartColors = {
    backgroundColor: 'white',
    lineColor: '#2962FF',
    textColor: 'black',
    areaTopColor: 'transparent',
    areaBottomColor: 'transparent',
  };

  const handleZoomFunction = (data: any) => {
    console.log(data, 'zooming data from parent');
  };

  const handleDragFunction = (data: any) => {
    console.log(data, 'Drag data from parent');
  };
  return (
    <AreaChart
      handleZoomFunction={handleZoomFunction}
      handleDragFunction={handleDragFunction}
      colors={chartColors}
      data={initialData}
    ></AreaChart>
  );
};

export default Chart;
